import styled from '@emotion/styled';

import vars from 'theme/styles/vars';

export default styled.div`
    background-color: #F3F3F3;

    @media all and (max-width: ${vars.mobileM}) {
        background-color: #FFFFFF;
    }
`;